// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__iBYyk","imageCustomSize":"styles_imageCustomSize__7viWg","imageFullWidth":"styles_imageFullWidth__9dJot"};